module.exports = __webpack_public_path__ + "img/av096.95c8ce02.png";